// React actually rendered, so the page is healthy — reveal it. The matching
// `html { visibility: hidden }` lives in gatsby-ssr.js and exists purely to
// avoid a flash of unstyled content before styled-components has injected.
export const onInitialClientRender = () => {
  document.documentElement.style.visibility = 'visible'
}
